module.exports = __webpack_public_path__ + "img/company_logo.8bc8051f.png";